import React from 'react';
import ReactDOM from 'react-dom';
import DriversTable from '../drivers-table.jsx';
if (document.getElementById(
  'react-component-g4-logistics-portal-view-driver-with-all-jobs')) {
  let driverId = document.getElementById(
    'react-component-g4-logistics-portal-view-driver-with-all-jobs'
  ).getAttribute('data-driver-id');
  ReactDOM.render(
    <DriversTable
      url = {"/api/v1/portal/drivers/view/"+driverId+'/all-jobs'}
      viewJustOneDriver={true}
      viewAllJobs={true}
      message_if_none = 'Driver not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-view-driver-with-all-jobs'
    )
  );
}
